export * from './anniversary-logo.component';
